<template>
  <transition name="fade">
    <div class="popup-wrapper" v-if="active">
      <div class="popup">
        <div class="popup__title text-medium">Дякую! Твій голос зараховано</div>
        <div class="popup__description">{{ name }} отримає {{ total }} балів і стане на крок ближче до участі у святі завдяки тобі!</div>
        <div class="d-flex button-group">
          <button @click="repeatVote" class="button button-default button_repeat" v-if="!disableLeft">Номінувати цього колегу знову</button>
          <button @click="newVote" class="button button-success button_next">Номінувати іншого</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['active', 'total', 'disableLeft', 'name'],
  data() {
    return {};
  },
  methods: {
    repeatVote() {
      this.$emit('repeatVote');
    },
    newVote() {
      this.$emit('newVote');
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';
.popup-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background: rgba(32, 33, 36, 0.24);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup {
  width: sm(327);
  background: $white;
  box-shadow: 0px 0px 13px rgba(32, 33, 36, 0.1);
  border-radius: sm(16);
  padding: sm(32);
  @include _1024 {
    width: sl(958);
    border-radius: sl(24);
    padding: sl(56);
  }
  @include _1920 {
    width: 958px;
    padding: 56px;
    border-radius: 24px;
  }
  &__title {
    font-size: sm(24);
    padding-bottom: sm(24);
    line-height: math.div(28.8, 24);
    @include _1024 {
      font-size: sl(32);
      padding-bottom: sl(32);
    }
    @include _1920 {
      font-size: 32px;
      padding-bottom: 32px;
    }
  }
  &__description {
    font-size: sm(16);
    line-height: math.div(22.4, 16);
    @include _1024 {
      font-size: sl(22);
    }
    @include _1920 {
      font-size: 22px;
    }
  }
}
.button_repeat + .button_next {
  @include _1024 {
    margin-left: sl(48);
  }
  @include _1920 {
    margin-left: 48px;
  }
}

.button-group {
  flex-direction: column-reverse;
  padding-top: sm(32);
  @include _1024 {
    padding-top: sl(48);
    flex-direction: row;
  }
  @include _1920 {
    padding-top: 48px;
  }
  .button {
    width: 100%;
    white-space: nowrap;
    font-size: sm(14);
    line-height: math.div(19.6, 14);
    padding: sm(14) sm(4);
    border-radius: sm(8);
    @include _1024 {
      font-size: sl(24);
      border-radius: sl(8);
      padding: sl(24);
      line-height: 1;
    }
    @include _1920 {
      font-size: 24px;
      border-radius: 8px;
      padding: 24px;
    }
    &_repeat {
      margin-top: sm(16);
      @include _1024 {
        margin-top: 0;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
